import {
  getInfiniteVehicleSystemFunction,
  getVehicleSystemFunction,
} from '@/common/queries/selections/vehicleSystem/vehicleSystemFunction';
import { queryOptions } from '@tanstack/react-query';
import { VehicleSystemParamsType } from '@/common/queries/selections/vehicleSystem/vehicleSystem.type';
import { getNextPage } from '@/modules/FileList/utils/getNextPage';
import { vehicleSystemSelectFunction } from '@/common/queries/selections/vehicleSystem/vehicleSystemSelectFunction';

export const getVehicleSystemOption = ({
  insurance,
  type,
  name,
}: VehicleSystemParamsType) =>
  queryOptions({
    queryKey: ['get_vehicle_system', insurance, type, name],
    queryFn: () => getVehicleSystemFunction({ insurance, type, name }),
  });

export const infiniteGetVehicleSystemOption = ({
  insurance,
  type,
  name,
}: VehicleSystemParamsType) => ({
  queryFn: () =>
    getInfiniteVehicleSystemFunction({
      insurance,
      type,
      name,
    }),
  queryKey: ['get_vehicle_system', insurance, type, name],
  initialPageParam: 1,
  getNextPageParam: getNextPage,
  select: vehicleSystemSelectFunction,
});
